import React from "react";
import { FaCopy } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

const resourcesData = [
  // User-related
  {
    endpoint: "/users",
    url: "https://fakestoreapi.noksha.dev/api/users",
    count: "100+ users",
    description: "User accounts with profiles, companies, and roles",
    title: "Users",
  },
  {
    endpoint: "/wishlists",
    url: "https://fakestoreapi.noksha.dev/api/wishlists",
    count: "50+ wishlists",
    description: "User wishlists with saved products",
    title: "Wishlists",
  },
  // Product-related
  {
    endpoint: "/products",
    url: "https://fakestoreapi.noksha.dev/api/products",
    count: "200+ products",
    description: "Product catalog with categories and inventory",
    title: "Products",
  },
  {
    endpoint: "/categories",
    url: "https://fakestoreapi.noksha.dev/api/categories",
    count: "50+ categories",
    description: "Product category hierarchy and organization",
    title: "Categories",
  },
  {
    endpoint: "/reviews",
    url: "https://fakestoreapi.noksha.dev/api/reviews",
    count: "800+ reviews",
    description: "Product reviews with ratings and comments",
    title: "Reviews",
  },
  {
    endpoint: "/amazonproducts",
    url: "https://fakestoreapi.noksha.dev/api/amazonproducts",
    count: "150+ products",
    description: "Amazon-style products with detailed listings",
    title: "Amazon Products",
  },
  {
    endpoint: "/walmartproducts",
    url: "https://fakestoreapi.noksha.dev/api/walmartproducts",
    count: "150+ products",
    description: "Walmart-style products with pricing and availability",
    title: "Walmart Products",
  },
  // Order-related
  {
    endpoint: "/orders",
    url: "https://fakestoreapi.noksha.dev/api/orders",
    count: "500+ orders",
    description: "Order management with status tracking",
    title: "Orders",
  },
  {
    endpoint: "/carts",
    url: "https://fakestoreapi.noksha.dev/api/carts",
    count: "150+ carts",
    description: "Shopping cart data with item management",
    title: "Carts",
  },
  {
    endpoint: "/payments",
    url: "https://fakestoreapi.noksha.dev/api/payments",
    count: "300+ payments",
    description: "Payment transactions with status and methods",
    title: "Payments",
  },
  {
    endpoint: "/coupons",
    url: "https://fakestoreapi.noksha.dev/api/coupons",
    count: "50+ coupons",
    description: "Discount codes with conditions and expiry",
    title: "Coupons",
  },
  // Content-related
  {
    endpoint: "/posts",
    url: "https://fakestoreapi.noksha.dev/api/posts",
    count: "250+ posts",
    description: "Blog posts and content management",
    title: "Posts",
  },
  {
    endpoint: "/comments",
    url: "https://fakestoreapi.noksha.dev/api/comments",
    count: "1000+ comments",
    description: "User comments on posts with threaded replies",
    title: "Comments",
  },
  {
    endpoint: "/photos",
    url: "https://fakestoreapi.noksha.dev/api/photos",
    count: "500+ photos",
    description: "Photo gallery with captions and metadata",
    title: "Photos",
  },
  // Task-related
  {
    endpoint: "/todos",
    url: "https://fakestoreapi.noksha.dev/api/todos",
    count: "300+ todos",
    description: "Task management with priorities and status",
    title: "Todos",
  },
  // System-related
  {
    endpoint: "/notifications",
    url: "https://fakestoreapi.noksha.dev/api/notifications",
    count: "400+ notifications",
    description: "User notifications for orders and promotions",
    title: "Notifications",
  },
];

const Resources = () => {
  const copyToClipboard = (item) => {
    navigator.clipboard.writeText(item?.url);
    toast.success(`${item?.title} URL copied to clipboard!`, {
      position: "top-right",
      duration: 3000,
      style: {
        background: "#2d3338",
        color: "#fff",
      },
    });
  };

  return (
    <div
      id="docs"
      className="max-w-7xl mx-auto pb-20 px-10 flex flex-col gap-6 py-5"
    >
      <Toaster />
      <div className="flex flex-col gap-4">
        <h1 className="text-3xl text-black font-bold">API Resources</h1>
        <p className="text-base max-w-96">
          Discover essential resources for building shopping prototypes with our
          free Fake Store API, including products, users, orders, and more.
        </p>
      </div>
      <div>
        <ul
          className="max-w-2xl flex flex-col gap-4 w-full"
          aria-label="Available Mock API Endpoints"
        >
          {resourcesData?.map((item) => (
            <li
              key={item.title}
              className="flex flex-col gap-1 font-titleFont text-primeColor font-normal border-b border-gray-200 pb-3 hover:border-primeColor ease-in-out duration-300 group"
            >
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <h3 className="text-lg font-bold">
                    <a
                      href={item.url}
                      className="text-blue-600 group-hover:text-primeColor hover:underline cursor-pointer underline-offset-2 ease-in-out duration-300"
                      title={`Fake API Endpoint for ${item.title}`}
                    >
                      {item.endpoint}
                    </a>
                  </h3>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold bg-gray-100 px-2 py-1 rounded text-gray-700">
                    {item.count}
                  </span>
                  <button
                    onClick={() => copyToClipboard(item)}
                    className="text-gray-500 hover:text-blue-600 active:scale-95 transition-all duration-300"
                    aria-label={`Copy Fake API JSON URL for ${item.title}`}
                  >
                    <FaCopy size={16} />
                  </button>
                </div>
              </div>
              <p className="text-sm text-gray-600 tracking-wide mt-1">
                {item.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <a
        href="https://www.reactbd.com/"
        className="w-52 px-4 h-12 rounded-md bg-primeColor text-white hover:bg-designColor hover:text-black duration-300 font-semibold font-titleFont flex items-center justify-center"
      >
        Learn about reactBD
      </a>
    </div>
  );
};

export default Resources;
